import {HexMath} from '../HexMath';

/**
 * Проверяет, есть ли у отряда игрока соседние отряды противника
 * @param {string} unitHexKey - hexKey отряда
 * @param {string} playerId - ID игрока
 * @param {Array} units - массив всех отрядов
 * @returns {boolean} - true если есть хотя бы один соседний отряд противника
 */
export const hasAdjacentEnemyUnit = (unitHexKey, playerId, units) => {
  const hexMath = new HexMath(30, 'flat');
  const [q, r] = unitHexKey.split(',').map(Number);
  const neighbors = hexMath.getNeighborsFlatTop(q, r);
  const neighborKeys = neighbors.map(([nq, nr]) => `${nq},${nr}`);

  return units.some(unit =>
    unit.ownerId !== playerId && neighborKeys.includes(unit.hexKey)
  );
};

/**
 * Проверяет, есть ли у игрока хотя бы один отряд с соседним отрядом противника
 * @param {string} playerId - ID игрока
 * @param {Array} units - массив всех отрядов
 * @returns {boolean} - true если есть хотя бы один отряд игрока с соседним противником
 */
export const hasAnyUnitWithAdjacentEnemy = (playerId, units) => {
  const playerUnits = units.filter(u => u.ownerId === playerId);

  return playerUnits.some(unit => hasAdjacentEnemyUnit(unit.hexKey, playerId, units));
};